import { useEffect, useRef, useState } from "react"

import { useEditor } from "@craftjs/core";

export default function EditableNodeName({ id, isEditing, groupHovered }) {
  const { name, actions: { setCustom } } = useEditor(({ nodes }) => ({
    name: nodes[id].data.custom.name,
  }));
  const inputRef = useRef(null)
  const editing = isEditing.value

  useEffect(() => {
    setTimeout(() => {
      if (editing) {
        inputRef.current?.focus()
        inputRef.current?.select()
      }
    }, 200)
  }, [editing])

  const handleEditFinish = () => {
    setCustom(id, custom => custom.name = inputRef.current.value)
    isEditing.setValue(false)
  }

  if (!editing) {
    return <ScrollableText name={name} isEditing={isEditing} groupHovered={groupHovered} />
  }

  return <div className='w-full'>
    <input
      ref={inputRef}
      className='border-none bg-transparent outline-none p-0 w-full'
      value={name}
      onChange={e => setCustom(id, custom => custom.name = e.target.value)}
      onBlur={handleEditFinish}
      onClick={evt => evt.stopPropagation()}
      onKeyDown={evt => evt.key === 'Enter' && handleEditFinish()}
      autoFocus
    />
  </div>
}

const ScrollableText = ({ name, isEditing, groupHovered }) => {
  const containerRef = useRef(null)
  const textRef = useRef(null)
  const [canScroll, setCanScroll] = useState(false)
  const [duration, setDuration] = useState()
  const [scrollWidth, setScrollWidth] = useState()

  useEffect(() => {
    const container = containerRef.current
    const text = textRef.current

    if (text?.scrollWidth > container?.clientWidth) {
      setDuration(text.scrollWidth * 10)
      setScrollWidth(text.scrollWidth - container.clientWidth)
      setCanScroll(true)
      return
    }

    setCanScroll(false)
  }, [name])

  return <>
    <div onDoubleClick={() => isEditing.setValue(!isEditing.value)} className='w-full pr-3 group-hover:pr-0 relative'>
      <div
        ref={containerRef}
        className='relative h-4 overflow-hidden group'
      >
        <span
          ref={textRef}
          style={{
            transitionDuration: `${duration}ms`,
            transitionProperty: 'transform',
            transform: canScroll && groupHovered ? `translateX(-${scrollWidth}px)` : 'translateX(0)',
          }}
          className="absolute left-0 whitespace-nowrap"
        >
          {name}
        </span>
      </div>
      {canScroll && <span className='-ml-1 group-hover:opacity-0 absolute right-0 top-0 '>...</span>}
    </div>
  </>
}
